export default __webpack_public_path__ + "static/up-icon-2485591c701bb48483fe40bc63a56036.png";